export const messages = {
  en: {
    resourceEnterDetailManage: {
      applyInfo: 'Application Information',
      auditStatus: 'Audit Status',
      applicant: 'Applicant',
      applyTime: 'Application Time',
      applyDesc: 'Application Description',
      applyMaterials: 'Application Materials',
      material: 'Material',
      materialCode: 'Material Code',
      unitPrice: 'Unit Price',
      stock: 'Stock',
      applyQuantity: 'Apply Quantity',
      enterQuantity: 'Enter Quantity',
      remark: 'Remark',
      operation: 'Operation',
      enter: 'Enter'
    },
    addResourceQuantity: {
      title: 'Enter Quantity',
      quantity: 'Quantity',
      quantityPlaceholder: 'Required, please enter the quantity',
      quantityRequired: 'Quantity cannot be empty'
    },
    common: {
      cancel: 'Cancel',
      save: 'Save',
      saveSuccess: 'Save successfully',
      saveFailed: 'Save failed'
    }
  },
  zh: {
    resourceEnterDetailManage: {
      applyInfo: '申请信息',
      auditStatus: '审核状态',
      applicant: '申请人',
      applyTime: '申请时间',
      applyDesc: '申请说明',
      applyMaterials: '申请物资',
      material: '物资',
      materialCode: '物资编码',
      unitPrice: '单价',
      stock: '库存',
      applyQuantity: '申请数量',
      enterQuantity: '入库数量',
      remark: '备注',
      operation: '操作',
      enter: '入库'
    },
    addResourceQuantity: {
      title: '入库数量',
      quantity: '数量',
      quantityPlaceholder: '必填，请填写入库数量',
      quantityRequired: '数量不能为空'
    },
    common: {
      cancel: '取消',
      save: '保存',
      saveSuccess: '保存成功',
      saveFailed: '保存失败'
    }
  }
}